import packageJson from '../package.json';
import { IVlanItem, ProjectDataType } from './context/global/types';
import { EDataType } from './modules/network-configuration/models/node-data';
import { PaperSize, ExportResolution } from './types/general';

export const APP_VERSION = packageJson.version;

/** When true, axios uses same-origin URLs and MSW mocks REST auth (no Supabase). */
export const isTestMode = import.meta.env.VITE_TEST_MODE === 'true';

export const appConfig = {
  apiUrl: isTestMode
    ? ''
    : 'https://pupjlshllzljaqngstsz.supabase.co/functions/v1',
  appSecretKey: 'mlVbwyZ4wo',
  enableGroupingNode: false,
  undoRedoStorageKey: 'tq-network-topology-undo-redo',
  currentStateStorageKey: 'tq-network-topology-current-state',
  imageSizeLimit: 1 * 1024 * 1024, // 1MB,
  storageLimit: 4 * 1024 * 1024, // 4MB,
  enableHistoryLocalStorage: false,
};

// Paper sizes in mm (width x height for portrait)
export const PAPER_SIZES: Record<PaperSize, { width: number; height: number }> =
  {
    A1: { width: 594, height: 841 },
    A2: { width: 420, height: 594 },
    A3: { width: 297, height: 420 },
    A4: { width: 210, height: 297 },
  };

// Resolution settings (pixel ratio)
export const RESOLUTION_SETTINGS: Record<
  ExportResolution,
  { pixelRatio: number; label: string }
> = {
  low: { pixelRatio: 1, label: 'Low (1x)' },
  medium: { pixelRatio: 2, label: 'Medium (2x)' },
  high: { pixelRatio: 3, label: 'High (3x)' },
  ultra: { pixelRatio: 4, label: 'Ultra (4x)' },
};

export const defaultProjectData: ProjectDataType = {
  projectName: 'My Project',
  companyName: 'TRONTEQ GmbH',
  companyAddress: 'Hoelzlestr. 3 72768 Reutlingen',
  drawnBy: '',
  revisionNumber: '',
  projectNumber: '',
  responsibleEngineer: '',
  description: '',
  exportSettings: {
    isVisible: false,
    frameOrientation: 'portrait',
    paperSize: 'A4',
    resolution: 'medium',
    width: PAPER_SIZES.A4.width,
    height: PAPER_SIZES.A4.height,
    positionX: 0,
    positionY: 0,
  },
};

export const connectionDefaultData: IVlanItem[] = [
  // {
  //   id: v4(),
  //   color: '#FF0000',
  //   vlanId: 1,
  //   ipSubnet: '',
  //   ip: '',
  //   subnetMask: '',
  //   description: 'VLAN 1',
  // },
  // {
  //   id: v4(),
  //   color: '#00FF00',
  //   vlanId: 2,
  //   ipSubnet: '',
  //   ip: '',
  //   subnetMask: '',
  //   description: 'VLAN 2',
  // },
  // {
  //   id: v4(),
  //   color: '#0000FF',
  //   vlanId: 3,
  //   ipSubnet: '',
  //   ip: '',
  //   subnetMask: '',
  //   description: 'VLAN 3',
  // },
];

export const STORAGE_KEY_ACCESS_TOKEN = 'tq_network_access_token';

export { defaultConnectionData } from './default-connection-data';

export const nodeZIndex = (type: EDataType) => {
  switch (type) {
    case EDataType.Group:
      return 2;
    case EDataType.Image:
      return 3;
    case EDataType.ProjectFrame:
      return 1;
    case EDataType.Note:
      return 20;
    default:
      return 10;
  }
};

export const WEB_UI_PATH = 'details';
export const WEB_UI_API_BASE_URL = '';
